/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowNe16: {
  name: 'arrow-ne-16';
  data: string;
} = {
  name: 'arrow-ne-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.913 2.41 9.54 14.408a1 1 0 0 1-1.906-.284L7.09 9.789a1 1 0 0 0-.882-.87l-4.32-.482a1 1 0 0 1-.301-1.906L13.586 1.09a1 1 0 0 1 1.327 1.32z"/></svg>`
};
